import { Environment, Network, RecordSource, Store } from "relay-runtime";
import fetch from "cross-fetch";

// Allows logging GraphQL requests queries and responses when run from Capybara.
const LOG_GRAPHQL_REQUESTS = window.CAPYBARA_ENV;

let requestIndex = 0;

const fetchQuery = async (operation, variables) => {
  // This allows for logging SQL requests in the "DEBUG" log level when run from the
  // capybara selenium driver, which allows debugging GraphQL requests as we have no
  // other mean of logging those requests in rspec.
  //
  // The requests logs can be retrieved in rspec/capybara using the dedicated helper
  // and requesting for the appropriate log level ("DEBUG") or all logs ("ALL")
  //
  //  Example : `display_javascript_logs_for(page, level: "DEBUG")`
  //
  const currentRequestIndex = requestIndex++;
  const logRequest = (...messages) => {
    if (!LOG_GRAPHQL_REQUESTS) return;
    console.debug(`[GQL #${currentRequestIndex}] ${messages.join(" ")}`);
  };

  logRequest(
    `Started operation ${operation.text} with variables : ${JSON.stringify(variables)}`
  );

  const onResponse = async response => {
    if (response.status >= 400) {
      logRequest(" * Response error : ", JSON.stringify(response));

      const error = new Error();
      error.response = await response.json();
      throw error;
    }

    return new Promise((resolve, _reject) => {
      response.json().then(data => {
        logRequest(" * Response data : ", JSON.stringify(data));

        resolve(data);
      });
    });
  };

  const endPoint =
    document && document.body.className.match(/(super-)?admin/)
      ? "/admin/graphql"
      : "/graphql";

  const locale = document.querySelector("html").lang;
  const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;

  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Accept-Language": locale
  };

  // Add the CSRF token to the headers if present. Test environment doesn't protect
  // against foregery, so we handle the case where the CSRF token is not here in the
  // client, which nevertheless would fail in production as expected.
  if (csrfToken) headers["X-CSRF-Token"] = csrfToken;

  return fetch(endPoint, {
    method: "POST",
    credentials: "include",
    headers,
    body: JSON.stringify({
      query: operation.text,
      variables
    })
  }).then(onResponse);
};

const network = Network.create(fetchQuery);
const source = new RecordSource();

// Expire queries after 10mn so a user that stays some time on the platform can see
// potential data changes when coming back to a previous page.
const store = new Store(source, { queryCacheExpirationTime: 10 * 60 * 1000 });

const appRelayEnvironment = new Environment({ network, store });

// Export the relay environment as default export, and add the relay store to allow
// it to be used for data expiration purposes.
export { appRelayEnvironment as default, store };
